import React from 'react';
import { useJourneyContext } from 'Contexts';
import { Icons } from 'Assets';

interface Props {
  message: string;
  readonly?: boolean;
}

export const EditablePreviousInput: React.FC<Props> = ({ message, readonly }) => {
  const { goBackOneStep } = useJourneyContext();

  return (
    <div className="flex justify-center w-full">
      <div className="flex items-center border border-light-silver rounded-full p-2 bg-white">
        <span className="mr-2 ml-2 idz_hide break-all">{message}</span>
        {!readonly && <img src={Icons.Pencil} alt="Éditer" className="mr-2 h-5 cursor-pointer" onClick={goBackOneStep} />}
      </div>
    </div>
  );
};
